import { api } from "./api";

export default {
    notify() {
        return api('/notify')
    },
    subscribe(email, name, tags) {
        return api('/subscribe', {email, name, tags});
    },
    unsubscribe(email) {
        return api('/unsubscribe', {email});
    }
}
